import React, { FC, useEffect, useRef, useState } from 'react';
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useConnection, useUserInfo } from '../../connection/Application';
import Titles from '../Titles/Titles';
import { Grid } from '@mui/material';
import { useQueryParam } from 'use-query-params';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const getWindowSize = () => {
  const { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
};

const Grade: FC = () => {
  const [category] = useQueryParam<string | undefined>('category');
  const [grade, setGrade] = useQueryParam<string | undefined>('grade');
  const [value, setValue] = useState<number>(0);
  const [oldCategory, setOldCategory] = useState<string | undefined>();
  const user = useUserInfo();
  const mainTitles = useRef<
    {
      description: string;
      id: string;
      subTitle: {
        description: string;
        id: string;
        title: string;
        orderNum: number;
        questionCount: number,
        doneQuestionCount: number,
      }[];
      title: string;
      url?: string;
      pdf?: string;
    }[]
  >([]);
  const [grades, setGrades] = useState<
    {
      grade: string;
      category: string;
      id: string;
      color: string;
      mainTitles: {
        description: string;
        id: string;
        subTitle: {
          description: string;
          id: string;
          title: string;
          icon?: string;
          orderNum: number;
          questionCount: number,
          doneQuestionCount: number,
        }[];
        title: string;
      }[];
      mainTitleCount: number,
      subTitleCount: number,
    }[]
  >([]);
  const [colors] = useState([
    '#0781C4',
    '#D93B0E',
    '#F98700',
    '#293E4F',
    '#8CA4B0',
    '#B757A1',
    '#F2649C'
  ]);
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const connection = useConnection();

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize(getWindowSize());
    };

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      console.log(user)
      if (!category) {
        return;
      }
      const category1 = await connection.get(user?.id ? `category/${category}/fn?userid=${user.id}`:`category/${category}/fn`);
      const body = category1?.response?.body;
      if (!body?.grades) {
        setGrades([]);
        mainTitles.current = [];
        return;
      }
      setGrades(
        body.grades.map((e: any, i: number) => ({
          grade: e.title,
          id: e.id,
          mainTitles: e.mainTitle,
          mainTitleCount: e.mainTitleCount,
          subTitleCount: e.subTitleCount,
          category: body.title,
          color: colors[i % 7],
        })),
      );
      if (!grade) {
        setGrade(body.grades[0]?.id);
        setValue(0);
        mainTitles.current = body.grades[0]?.mainTitle ?? [];
      } else {
        const x = body.grades.findIndex((y: any) => y.id === grade);
        if (oldCategory !== undefined && oldCategory !== category) {
          setGrade(body.grades?.[0]?.id);
          setValue(0);
          mainTitles.current = body.grades[0]?.mainTitle ?? [];
        } else {
          if (x === -1) {
            setGrade(body.grades?.[0]?.id);
            setValue(0);
            mainTitles.current = body.grades[0]?.mainTitle ?? [];
          } else {
            setValue(x);
            mainTitles.current = body.grades[x]?.mainTitle ?? [];
          }
        }
        setOldCategory(category);
      }
    };
    fetchData();
  }, [colors, category, connection, user]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setGrade(grades[newValue].id);
    mainTitles.current = grades[newValue].mainTitles;
  };

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  return (

    <Grid
      style={{
        display: 'flex',
        padding: windowSize.innerWidth > 1754 ? `0 ${windowSize.innerWidth > 1774  ? 58 :50 + (windowSize.innerWidth - 1754) / 2}px 20px 0` : '0 50px 20px 0',
        justifyContent: 'center' 
      }}
    >
      <Tabs
        sx={{
          paddingTop: '50px',
          width: 50,
          // height: '73vh',
          '& .MuiTabs-flexContainer': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
          },
          '& .MuiTabs-indicator': {
            left: '43px',
            height: '63px !important',
            marginTop: '10px !important',
            width: '5px !important',
          },
          [`& .${tabsClasses.scrollButtons}`]: {
            '&.Mui-disabled': { opacity: 0.3 },
          },
        }}
        variant='fullWidth'
        scrollButtons={(windowSize.innerHeight * 73) / 100 / 70 < grades.length}
        orientation='vertical'
        value={value}
        onChange={handleChange}
        style={{ width: '110px' }}
        aria-label='icon label tabs example'>
        {grades.map((e, i) => (
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} key={e.id} onClick={() => {
            setValue(i);
            setGrade(grades[i].id);
            mainTitles.current = grades[i].mainTitles;
          }}>
            <Tab
              key={e.id}
              label={e.grade}
              sx={{
                '&.MuiButtonBase-root': {
                  minWidth: matches ? '35px' : '50px',
                  padding: matches ? '12px 4px 12px 4px' : '12px 16px 12px 16px',
                },
                '&.MuiButtonBase-root::after': {
                  width: '10px',
                  backgroundColor: i === value ? e.color : 'white',
                }
              }}
              style={{
                boxShadow:
                  'rgb(0 0 0 / 20%) 0px 54px 55px, rgb(0 0 0 / 7%) 0px -12px 30px, rgb(0 0 0 / 7%) 0px 4px 6px, rgb(0 0 0 / 12%) 0px 12px 13px, rgb(0 0 0 / 4%) 0px -3px 5px',
                color: i === value ? e.color: 'white',
                backgroundColor: i === value ? 'white' : e.color,
                width: 50,
                height: 63,
                margin: '10px 0',
                opacity: 0.9,
              }}
            />
            <div style={{
              height: '50px',
              width: '12px',
              backgroundColor:  i === value ? 'white' : '#D9D9D9',
              borderRight: i === value ?  'none' : '2px solid #8C8C8C',
              borderLeft: i === value ? '2px solid #D9D9D9' : 'none',
            }}> </div>
          </div>
        ))}
      </Tabs>
      <Titles
        mainTitles={mainTitles.current}
        category={grades.find((e) => e.id === grade)?.category ?? ''}
        grade={grades.find((e) => e.id === grade)?.grade ?? ''}
        mainTitleCount={grades.find((e) => e.id === grade)?.mainTitleCount ?? 0}
        subTitleCount={grades.find((e) => e.id === grade)?.subTitleCount ?? 0}
      />
    </Grid>
  );
};

export default Grade;
